import React from 'react'
import { Text } from '../../elements/Text'
import { getHashOnlyUrl, mq } from 'marketing-site/src/library/utils'
import { IProps } from './index'
import classnames from 'classnames'

export function SecondaryNavMenuItem({ title, subtitle, url }: IProps): React.ReactElement {
  return (
    <div
      className={classnames('item-container', { 'no-subtitle': !subtitle })}
      data-testid="header-navigation-menu-item"
    >
      <a href={getHashOnlyUrl(url)} role="menuitem">
        <div className="content">
          <div className="title">
            <div className="title-text">
              <Text brand="default" size="body">
                {title}
              </Text>
            </div>
          </div>
          {subtitle && (
            <div>
              <Text brand="default" size="caption">
                {subtitle}
              </Text>
            </div>
          )}
        </div>
      </a>
      <style jsx>
        {`
          .item-container {
            display: flex;
            flex: 0 1 auto;
            width: 100%;
            margin-top: 1.75rem;

            a {
              @include focusable();
              display: flex;
              color: $slate;

              &:hover {
                text-decoration: none;
                .title .title-text {
                  text-decoration: underline;
                }
              }

              &:focus {
                outline: 0;
              }
            }
          }

          .icon-wrapper {
            margin-right: 1.25rem;
            padding-top: 0.25rem;
          }

          .content {
            display: flex;
            flex-direction: column;
          }

          .title {
            display: flex;
            margin-bottom: 0.25rem;
          }

          @media (${mq.desktop}) {
            .item-container {
              margin-top: 1.25rem;
            }
          }

          @media (${mq.desktopLg}) {
            .item-container {
              margin-top: 0;
              margin-bottom: 1.5rem;

              &.no-subtitle {
                margin-bottom: 1.125rem;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
